/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import EmptyState from '@atlaskit/empty-state/empty-state';
import Box from '@atlaskit/primitives/box';
import { xcss } from '@atlaskit/primitives/xcss';
import Link from '@atlaskit/link/link';
import { useIntl, defineMessage } from '@atlassian/jira-intl';
import LockImage from './lock.svg';

const errorTitle = defineMessage({
	id: 'spa-assets-app-base.no-access-error-page.error-title',
	defaultMessage: 'You need permission to access this page',
	description: 'Error page title for when users do not have permission to access the page',
});

const errorDescription = defineMessage({
	id: 'spa-assets-app-base.no-access-error-page.error-description',
	defaultMessage: 'If you think you should have access, contact your admin.',
	description:
		'The description for the error page for when users do not have permission to access the page',
});

const goToHomeLinkLabel = defineMessage({
	id: 'spa-assets-app-base.no-access-error-page.go-to-home-link-label',
	defaultMessage: 'Go to Atlassian Home',
	description: 'The label for the link that navigates the user to the Atlassian home page',
});

export const NoAccessErrorPage = (): React.JSX.Element => {
	const { formatMessage } = useIntl();
	return (
		<Box xcss={containerStyles}>
			<EmptyState
				imageUrl={LockImage}
				header={formatMessage(errorTitle)}
				description={formatMessage(errorDescription)}
				tertiaryAction={
					<Link href="https://home.atlassian.com">{formatMessage(goToHomeLinkLabel)}</Link>
				}
			/>
		</Box>
	);
};
const containerStyles = xcss({
	display: 'flex',
	height: '100%',
	placeItems: 'center',
});
